module.exports = __webpack_public_path__ + "img/disabled-edit.6eabaf1d.svg";